export const clipboardCopy = (text: string): void => {
  const input = document.createElement('input')
  input.setAttribute('value', text)
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    input.contentEditable = 'true'
    input.readOnly = false
    document.body.appendChild(input)
    const range = document.createRange()
    range.selectNode(input);
    (window as any).getSelection().addRange(range)
  } else {
    document.body.appendChild(input)
  }
  
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)
}
